export default `
  <div class="wb-doc-page">
    <div class="doc-text doc-pt16 doc-pb28">更新日期：2021年12月3日</div>

    <div class="doc-text">*提示</div>
    <div class="doc-text doc-pb28">本服務協議內容包括服務條款、免責聲明兩部分。請您務必認真閱讀、充分理解本協議。您確認您具備完全民事權利能力和完全民事行為能力，有能力閱讀、同意並遵守本協議，並對您本協議項下的全部行為獨立承擔法律責任。</div>

    <div class="doc-text doc-pb28">
      <a class="doc-link" href="javascript:void(0);">《盈寶隱私政策》</a>
      以及盈寶公佈的其他協議規範、規則、聲明、公告、政策等（以下統稱“其他盈寶規則”）是本協議不可分割的組成部分，您在使用盈寶服務時應同樣遵守。您接受並同意本協議的行為即視為您同意並接受其他盈寶規則，您接受並同意任一其他盈寶規則的行為亦視為您接受並同意本協議。
    </div>

    <div class="doc-text doc-pb28">若您下載、安裝、使用或接入盈寶軟體，即表示確認及同意本協議項下所有條款。盈寶手機應用APP有權於任何時間修改或變更本服務協議之內容，建議您隨時注意修改或變更。您於任何修改或變更後繼續使用本應用時，將視為您已閱讀、了解並同意接受該等修改或變更。</div>

    <div class="doc-text doc-pb28">如您不同意本協議任意內容，請不要註冊或使用盈寶相關服務。如您通過註冊程序，即表示您與盈寶達成協議，自願接受相關服務條款、免責聲明以及隱私政策等所有協議內容。此後，用戶不得以未閱讀本協議內容作任何形式的抗辯。</div>

    <div class="doc-text">您在使用盈寶某特定服務時，該服務可能會另有單獨的協議、相關業務規則等，使用該項服務前請閱讀並同意相關的單獨協議。您使用前述特定服務，即視為您接受相關單獨協議</div>

    <div class="doc-main-title">服務條款</div>

    <div class="doc-text doc-pb28">您在使用盈寶某特定服務時，該服務可能會另有單獨的協議、相關業務規則等，使用該項服務前請閱讀並同意相關的單獨協議。您使用前述特定服務，即視為您接受相關單獨協議和相應的業務規則。</div>

    <div class="doc-text doc-pb28">（一）盈寶軟體使用說明</div>
    <div class="doc-text doc-pb28">盈寶授權您個人一項有限的、可撤銷的、不可轉讓的、不可轉授權的及非排他性的使用盈寶軟體的許可。您僅可出於訪問或使用本軟體提供之服務的目的而使用，本協議未授權的其他一切權利仍由盈寶保留。</div>

    <div class="doc-text doc-pb28">（二）軟體的獲取、安裝及更新</div>
    <div class="doc-text doc-pb28">1. 您可以直接從盈寶官網等渠道下載盈寶軟體，也可以從得到盈寶授權的第三方獲取。若您從未經合法授權的第三方獲取盈寶軟體，盈寶無法保證該軟體的安全性和正常使用，亦不承擔由此造成的任何不利後果。</div>
    <div class="doc-text doc-pb28">2. 盈寶為不同的終端設備開發了不同的盈寶軟體版本，您應當根據實際情況選擇下載合適的版本進行安裝。</div>
    <div class="doc-text doc-pb28">3. 為了提升用戶體驗、完善服務內容、保證服務的安全性，我們有權隨時對軟體進行更新或者對軟體的部分功能效果進行改變或限制。</div>

    <div class="doc-text doc-pb28">（三）請您正確使用盈寶軟體，不得：</div>
    <div class="doc-text doc-pb28">1. 自行或者授權他人、第三方軟體對本軟體及其組件、模塊、數據進行干擾；</div>
    <div class="doc-text doc-pb28">2. 對盈寶擁有所有權或知識產權的內容進行使用、出租、複製、修改、鏈接、轉載、彙編、發表、出版、建立鏡像站點等；</div>
    <div class="doc-text doc-pb28">3. 其他未經盈寶明示授權的行為。</div>

    <div class="doc-text doc-pb28">（四）用戶行為規範</div>
    <div class="doc-text doc-pb28">您應對註冊獲得的盈寶用戶賬號（以下簡稱“賬號”）項下的一切行為承擔全部責任，同意不利用盈寶軟體和盈寶服務從事下列行為，否則我們有權對違反本協議內容的用戶作出禁止註冊及/或封號的處理：</div>
    <div class="doc-text doc-pb28">1. 發布、傳送、傳播、儲存違反證券法規及相關證券交易所規則的資訊，無論故意與否；</div>
    <div class="doc-text doc-pb28">2. 發布、傳送、傳播、儲存違反國家及當地法律法規的內容；</div>
    <div class="doc-text doc-pb28">3. 發布、傳送、傳播、儲存侵害他人名譽權、肖像權、知識產權、商業秘密等合法權利的內容；</div>
    <div class="doc-text doc-pb28">4. 發布、傳送、傳播、儲存侵犯其他用戶或第三方合法權益內容的資訊；</div>
    <div class="doc-text doc-pb28">5. 發布、傳送、傳播、儲存涉及他人隱私、個人資訊或資料的內容；</div>
    <div class="doc-text doc-pb28">6. 發布、傳送、傳播騷擾資訊、廣告資訊、垃圾資訊、或含有任何性或性暗示資訊的內容；</div>
    <div class="doc-text doc-pb28">7. 發布、傳送、傳播謠言、虛假資訊或其他含有不實資訊的內容；</div>
    <div class="doc-text doc-pb28">8. 發布、傳送、傳播、儲存干擾盈寶軟體和服務正常運營的資訊；</div>
    <div class="doc-text doc-pb28">9. 發布、傳送、傳播、儲存其他違反法律法規、政策及公序良俗、社會公德的資訊。</div>

    <div class="doc-text doc-pb28">（五）用戶注意</div>
    <div class="doc-text doc-pb28">1. 盈寶軟體使用過程中可能產生數據流量的費用，您需自行向運營商了解相關資費資訊，並自行承擔相關費用。</div>
    <div class="doc-text doc-pb28">2. 您應妥善保管賬號資訊、賬號密碼以及其他與賬號相關的資訊、資料。如因您的原因，造成賬號資訊、資料、數據的變動、滅失或財產損失等，您應立即通知盈寶並自行承擔相關法律後果。</div>
    <div class="doc-text doc-pb28">3. 盈寶會盡其商業上的合理努力保障您在盈寶軟體和盈寶服務中的數據存儲安全。</div>
    <div class="doc-text doc-pb28">4. 在任何情況下，請不要應輕信借款、索要密碼或其他涉及財產的資訊。涉及財產操作的，請務必事前進行核實及確認，並請經常留意相關防範詐騙犯罪的提示。</div>
    <div class="doc-text doc-pb28">5. 手機應用包含的內容和資訊是根據公開資料分析和演釋，該公開資料是從可靠來源蒐集，手機應用竭力確保所提供資訊的準確和可靠度，但不能保證其絕對準確和可靠，且亦不會承擔因任何不准確或遺漏而引起的任何損失或損害的責任（不管是否侵權法下的責任或合約責任又或其它責任）。手機應用的行情價格、圖表僅作為購買或出售的參考依據，請您謹慎對待。</div>
    <div class="doc-text doc-pb28">6. 手機應用對於您手機應用鏈接到其它網站而下載的軟體或資料或使用的服務，不負任何擔保責任。您應於下載和使用前自行斟酌與判斷前述軟體、服務或資料的合法合規性、合適性、有效性、正確性、完整性及是否侵害他人權利，以免遭受損失(例如: 造成您電腦系統受損或儲存資料流失等)，手機應用對於該等損失不負任何賠償責任。</div>
    <div class="doc-text doc-pb28">7. 手機應用隨時會與其它公司合作，並由其提供包括新聞、資訊、電子報等不同的內容供網站及手機應用刊登，手機應用在刊登時均將註明內容提供者。基於尊重內容提供者之知識產權，手機應用對其提供之內容並不做實質之審查或修改，對該等內容之正確真偽亦不負任何責任。對該等內容之正確真偽，您應自行判斷。您若認為某些內容涉及侵權或有所不實，請徑自向該內容提供者反映意見。</div>
    <div class="doc-text doc-pb28">8. 手機應用所使用的軟體或程序、手機應用上所有內容，包括但不限於著作、圖片、檔案、資訊、資料、網站架構，均由手機應用或其他權利人依法擁有其知識產權，包括但不限於商標權、專利權、著作權、商業秘密與專有技術等。任何人不得擅自實施使用、修改、重製、公開播送、改作、散佈、發行、公開發表、進行還原工程、解編或反向組譯等侵權行為。若您準備引用或轉載前述軟體、程序內容，必須依法取得手機應用或其他權利人的事前書面同意。尊重知識產權為您應盡的義務，如有違反，您應對手機應用、其他權利人負損害賠償責任(包括但不限於訴訟費及律師費等)。如因您的行為造成盈寶遭受其他權利人追訴的，盈寶有權向您追究一切法律責任。</div>
    <div class="doc-text doc-pb28">9. 就本服務提供過程中的任何證券交易所的行情資訊（以下稱"行情資訊"），您保證和承諾不以任何方式複製或向任何機構或個人提供全部或部分該等行情資訊，保證不以任何方式將全部或部分行情資訊用於非法目的，保證不將全部或部分行情資訊用於開發衍生產品，保證不對提供服務的軟體產品進行破解。您同意並保證不得利用本服務從事侵害他人權益或違法之行為。如用戶未能遵守本文中關於行情資訊的條款及細則，盈寶將在任何時間自動終止和切斷行情數據的流動，並不承擔任何法律責任和/或向用戶提供任何補償。</div>
    <div class="doc-text">10. 您同意並承諾不會將盈寶軟體或盈寶服務提供的市場數據的全部或其任何部分以任何方式再行發布或傳播，或用於指數計算和彙編，或用於導出任何可交易產品，或用於其他任何目的。</div>

    <div class="doc-main-title">免責聲明</div>

    <div class="doc-text doc-pb28">1. 您確認並承諾在使用盈寶軟體或在接受盈寶服務時，您應對金融市場常識有一定的了解，並充分知悉相關市場風險。</div>

    <div class="doc-text doc-pb28">2. 您理解並同意，盈寶不保證盈寶服務一定能滿足您的要求，也不保證服務不會中斷，對服務的及時性、準確性不作保證。您使用盈寶軟體及盈寶服務所存在或導致的風險將完全由您自己承擔。您因使用盈寶服務而產生的一切後果也由您自己承擔，盈寶對您不承擔任何責任，該等風險或後果包括但不限於：</div>
    <div class="doc-text doc-pb28">(1) 因電腦病毒、木馬、黑客攻擊、系統不穩定、第三方服務瑕疵、政府行為及其他不可抗力等因素導致的服務中斷、數據或資料丟失、洩露或損毀以及其他的損失和風險；</div>
    <div class="doc-text doc-pb28">(2) 您或盈寶的電腦軟體、系統、硬件和通信線路出現故障導致的服務中斷、數據或資料丟失、洩露或損毀以及其他的損失和風險；</div>
    <div class="doc-text doc-pb28">(3) 您操作不當或通過非盈寶授權的方式使用盈寶服務帶來的損失和風險；</div>
    <div class="doc-text doc-pb28">(4) 您通過盈寶軟體中的鏈接訪問第三方網站時，因第三方網站及內容所可能帶來的損失和風險；</div>
    <div class="doc-text doc-pb28">(5) 您的上傳內容被他人轉發、分享，因此等傳播可能帶來的風險和責任；</div>
    <div class="doc-text doc-pb28">(6) 由於網絡信號不穩定、網絡帶寬小等原因，所引起的登錄失敗、資料同步不完整、頁面打開速度慢可能帶來的風險和責任；</div>

    <div class="doc-text">3. 通過對任何市場數據的使用，您同意並確認:</div>
    <div class="doc-text doc-pb28">香港交易所資訊服務有限公司、其控股公司及／或該等控股公司的任何附屬公司盡力保證所提供資訊的準確和可靠度，但不能確保其絕對準確和可靠，亦不對因資訊不准確或遺漏而導致的任何損失或損害承擔責任（不管是否侵權法下的責任或合約責任又或其他責任）。</div>

    <div class="doc-text doc-pb28">4. 手機應用所載或透過該平台所存取的任何數據及材料僅供一般參考之用，不應被視為投資意見，並且不應作為作出商業決定的基礎。儘管盈寶將致力確保數據的準確性，但盈寶對任何錯誤或遺漏概不承擔任何責任。</div>

    <div class="doc-text doc-pb28">5. 手機應用所載或透過該平台存取的數據及材料在任何司法管轄區內均不構成任何證券、金融產品或工具要約、招攬、建議、意見或任何保證。</div>

    <div class="doc-text doc-pb28">6. 手機應用的資訊和內容是基於（現況）及（現有）提供，如有更改恕不另行通知，請您密切關注手機應用最新動態。</div>

    <div class="doc-text doc-pb28">7. 盈寶對於任何從手機應用有關服務所獲得的資訊、內容或廣告，不聲明或保證其內容之正確性或可靠性。對於您透過本手機應用上之廣告、資訊或邀約而展示、購買或取得之任何產品、資訊資料，盈寶亦不負品質保證之責任。</div>

    <div class="doc-text doc-pb28">8. 手機應用也許鏈接用戶有興趣的網站，儘管上述資訊乃基於盈寶認為可靠的來源，但盈寶並不保證其準確性，而資訊亦可能屬於不完整或過時。接入第三方網站鏈接的風險概由用戶自行承擔。盈寶不會調查、核實、監察或贊同其內容、準確性、所表達的意見，以及該等資源提供的其他連結。</div>

    <div class="doc-text doc-pb28">9. 鑑於互聯網的特性，手機應用所提供的服務有時可能會出現中斷、故障等不可抗力現象，或許將造成您使用上的不便、資料丟失、錯誤、遭人篡改或其它經濟上損失等情形。您在使用手機應用所提供的服務時應自行採取防護措施。手機應用對您因上述原因使用(或無法使用)本手機應用所提供的服務而造成的損害，不負任何賠償責任。</div>

    <div class="doc-text doc-pb28">針對以上各種風險，希望您學會自我保護，掌握適當的電腦和手機操作經驗和安全防範知識，一旦發現賬戶或手機異常，盡快與盈寶取得聯繫妥善處理。</div>
  </div>
`
